interface NutritionTotals {
  carbohydrate_content_g: number;
  dietary_fiber_g: number;
  net_carbs_g: number;
  sugar_g: number;
  protein_content_g: number;
  fat_content_g: number;
  trans_fat_g: number;
  saturated_fat_g: number;
  calorie_content_kcal: number;
  GI_estimate: number;
  GL_estimate: number;
}

interface FoodItem {
  id: number;
  weight: number;
}

interface NutritionFactsCardProps {
  nutritionTotals: NutritionTotals | null;
  foodItems: FoodItem[];
}

const NutritionFactsCard: React.FC<NutritionFactsCardProps> = ({
  nutritionTotals,
  foodItems,
}) => {
  if (!nutritionTotals) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-border bg-card p-5 shadow-lg">
      <h2 className="mb-4 text-lg font-bold text-foreground">
        Total Nutrition
      </h2>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">
            Calories
          </p>
          <p className="text-2xl font-bold text-primary">
            {nutritionTotals.calorie_content_kcal.toFixed(2)}
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">Protein</p>
          <p className="text-2xl font-bold text-chart-1">
            {nutritionTotals.protein_content_g.toFixed(2)}g
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">Carbs</p>
          <p className="text-2xl font-bold text-chart-2">
            {nutritionTotals.carbohydrate_content_g.toFixed(2)}g
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">Fat</p>
          <p className="text-2xl font-bold text-chart-3">
            {nutritionTotals.fat_content_g.toFixed(2)}g
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">Sugar</p>
          <p className="text-2xl font-bold text-chart-4">
            {nutritionTotals.sugar_g.toFixed(2)}g
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">Fiber</p>
          <p className="text-2xl font-bold text-chart-5">
            {nutritionTotals.dietary_fiber_g.toFixed(1)}g
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">
            GI (avg)
          </p>
          <p className="text-2xl font-bold text-orange-500">
            {Math.round(nutritionTotals.GI_estimate)}
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-sm font-semibold text-muted-foreground">GL</p>
          <p className="text-2xl font-bold text-purple-500">
            {Math.ceil(nutritionTotals.GL_estimate)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NutritionFactsCard;
